<template>
    <div>
        <div class="d-none">
            <slot></slot>
        </div>

        <div v-b-tooltip.hover.left :title="tooltipText" class="print-button">
            <button class="btn btn-sm btn-outline-secondary w-100" :disabled="isPrinting" @click="print">
                <span v-if="showLabel">
                    Imprimir
                </span>
                <b-icon icon="printer-fill"/>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrintWindow',

    props: {
        tooltip: String,
        title: {
            type: String,
            default: 'Documento'
        },
        showLabel: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            isPrinting: false
        }
    },

    computed: {
        tooltipText() {
            return this.showLabel ? null : this.tooltip;
        }
    },

    methods: {
        print() {
            const printWindow = window.open('', '_blank');
            const content = this.$el.cloneNode(true);

            // Remove the print button from the cloned content
            const button = content.querySelector('.print-button');
            if (button) {
                button.remove();
            }
            
            // Get all stylesheet links from the current document
            const styleSheets = Array.from(document.styleSheets)
                .map(styleSheet => {
                    if (styleSheet.href) {
                        return `<link rel="stylesheet" href="${styleSheet.href}" />`;
                    }
                    return '';
                })
                .filter(Boolean)
                .join('\n');

            // Get all style tags from the current document
            const styleTags = Array.from(document.getElementsByTagName('style'))
                .map(styleTag => {
                    return `<style>${styleTag.innerHTML}</style>`;
                })
                .filter(Boolean)
                .join('\n');

            const resetDisplayNoneClass = `<style>.d-none { display: block !important; }</style>`;
            
            const htmlContent = `<!DOCTYPE html>
                <html>
                <head>
                    <title>${this.title}</title>
                    ${styleSheets}
                    ${styleTags}
                    ${resetDisplayNoneClass}
                    <style>
                        @media print {
                            body {
                                display: block;
                                padding: 20px;
                            }
                                
                            thead {
                                display: table-header-group;
                            }
                            tfoot {
                                display: table-footer-group;
                            }
                        }

                        @media screen {
                            body {
                                display: none;
                            }
                        }
                    </style>
                </head>
                <body>
                    ${content.innerHTML}
                    <${'script'}>
                        window.onload = function() {
                            window.print();
                            window.close();
                        }
                    </${'script'}>
                </body>
                <style>
                </style>
                </html>`;

            printWindow.document.write(htmlContent);
            printWindow.document.close();
        }
    }
}
</script>
